// @ts-strict-ignore
/** @jsx jsx */
/** @jsxFrag null */
import {jsx} from 'panel';

import {MarkdownEl} from 'common/components/markdown';

import type {Tooltip} from './index';
import {ArrowType, DisplaySize} from './types';

export function template(this: Tooltip) {
  const {visibility} = this.state;
  const imageUrl = this.attr(`image-src`);
  const {print} = this.getContext(`i18n`);
  const text = this.params.text ? print(this.params.text) : this.attr(`text`);
  return (
    <div
      sel='.mp-tooltip'
      class={{
        'is-tooltip-tour': this.attr(`is-tooltip-tour`),
        'is-dot-line-arrow': this.attr(`arrow-type`) === ArrowType.LineDot,
        'has-max-width': this.attr(`max-width`) !== null || this.attr(`size`) !== DisplaySize.Fit,
        'is-animated': this.helpers.shouldAnimateTooltip(),
        'has-image': !!imageUrl,
        [`is-${visibility}`]: true,
        [`size-${this.attr(`size`)}`]: true,
        'break-word': this.attr(`break-word`),
        'non-blocking': this.attr(`non-blocking`),
      }}
      style={{
        ...(this.attr(`max-width`) && {
          'max-width': this.attr(`max-width`),
          hyphens: `auto`,
        }),
        ...(this.attr(`text-align`) && {
          'text-align': this.attr(`text-align`),
        }),
        '--tooltip-offset': `${this.helpers.getOffset()}px`,
      }}
      on={{
        click: this.helpers.stopPropagation,
        mousedown: this.helpers.stopPropagation,
        mouseleave: (ev) => this.hide(ev),
      }}
    >
      {imageUrl && <img sel='.mp-tooltip-image' attrs={{src: imageUrl}} />}
      <slot />

      {/**
       * don't render the MarkdownEl component until the tooltip is visible because the component does markdown formatting in connectedCallback(),
       * which is not noticeably slow by itself (maybe 1-2ms) but adds up if the page has many available tooltips
       */}
      {text && visibility !== this.helpers.VISIBILITY_HIDDEN && (
        <MarkdownEl sel='.mp-tooltip-text' attrs={{text: text.toString()}} /> // mp markdown expects type string not Translatable
      )}
      {visibility !== this.helpers.VISIBILITY_HIDDEN && this.lazyContentRenderer?.(this.getContext(`i18n`))}
      {this.attr(`arrow-type`) === ArrowType.Default && !this.attr(`is-tooltip-tour`) ? (
        <div sel='.mp-tooltip-arrow' />
      ) : null}
    </div>
  );
}
